<template>
  <div class="play-button-box">
    <button
      v-if="!isLoading"
      type="button"
      class="basic-detail-button-style"
      :disabled="isButtonDisabled"
      @click.prevent="executeAction"
    >
      {{ buttonDisplay }}
    </button>
  </div>
</template>
<script setup>
  import { defineProps, ref, computed } from 'vue'
  import { usePlayerActionButton } from '@/common/use/usePlayerActionButton'
  import {
    CONTENT_STATUS,
    ACTION_DISPLAY,
    ACTION_STATE,
  } from '@/common/utils/action-button/const'
  import { useRoute } from 'vue-router/composables'

  const route = useRoute()
  const props = defineProps({
    contentInfo: {
      type: Object,
      default: () => ({}),
    },
    landingInfo: {
      type: Object,
      default: () => ({}),
    },
    contentType: {
      type: String, // vod/ movie/ qvod/ live
      default: '',
    },
  })

  const buttonAction = ref('')
  const buttonDisplay = ref('')
  const isComingSoon = ref(false)

  const typeM = computed(() => props.contentInfo?.couninfo?.typeM || '0')
  const isMovieComingSoon = computed(() => Number(typeM) < 1)
  const isMovie = computed(() => props.contentType === 'movie')
  const contentStatus = computed(() => props.landingInfo?.contents_status || '')
  const isVodComingSoon = computed(() => contentStatus.value === 'commingsoon')
  const viewTime = computed(() => props.contentInfo?.viewtime || '0')
  const movieStatus = computed(() =>
    Number(viewTime.value) > 0 ? CONTENT_STATUS.CONTINUE : CONTENT_STATUS.BEGIN,
  )
  const streamStatus = computed(() =>
    isMovie.value ? movieStatus.value : contentStatus.value,
  )

  const {
    isButtonDisabled,
    isLoading,
    getActionButton,
    actionLogin,
    actionPurchase,
    actionStream,
  } = usePlayerActionButton(streamStatus.value)

  const executeAction = () => {
    switch (buttonAction.value) {
      case ACTION_STATE.LOGIN:
        actionLogin()
        break

      case ACTION_STATE.PURCHASE:
        actionPurchase(props.contentType, props.contentInfo)
        break

      case ACTION_STATE.STREAM:
        actionStream(props.contentType, props.landingInfo, route.query)
        break

      case ACTION_STATE.NONE:
        break
    }
  }

  const getComingSoonState = () => {
    return isMovie.value ? isMovieComingSoon.value : isVodComingSoon.value
  }

  const init = async () => {
    isComingSoon.value = getComingSoonState()

    if (isComingSoon.value) {
      isButtonDisabled.value = true
      buttonDisplay.value = ACTION_DISPLAY.COMING_SOON

      return
    }

    const { action = '', display = '' } = await getActionButton({
      contentType: props.contentType,
      contentInfo: props.contentInfo,
    })

    buttonAction.value = action
    buttonDisplay.value = display
  }

  init()
</script>
